import Vue from 'vue'
import { LIMIT_LARGE } from '@shared/constants/pagination'
import { computed, Ref, ref } from '@vue/composition-api'
import { updateParams } from '@/utils/router'

export type Pagination = {
  limit: number,
  currentPage: number,
  skip: number,
}

// We have to use `root.$router` here instead of `@/router`,
// as the latter is not reactive and `currentPage` won't change.
export default function usePagination ({
  root,
  limit = LIMIT_LARGE,
  page = ref(0),
}: {
  root: Vue;
  limit?: number;
  page?: Ref<number>;
}) {
  const currentPage = computed(() => Number(page.value || root.$route.params.page || 1))
  const pagination = computed<Pagination>(() => ({
    limit,
    currentPage: currentPage.value,
    skip: currentPage.value * limit - limit,
  }))

  return {
    pagination,
    updatePagination,
    updateLocalPagination,
  }

  function updatePagination ({ toPage }: { toPage: number }) {
    const newRoute = updateParams(root.$route, { page: toPage })
    root.$router.replace(newRoute)
  }

  function updateLocalPagination ({ toPage }: { toPage: number }) {
    page.value = toPage
  }
}

export function emptyPagination (): Pagination {
  return {
    limit: 0,
    skip: 0,
    currentPage: 0,
  }
}
